import MyAppointments from "./myAppointments";
import myAppointmentsAdapter from "./my-appointments.adapter";

export default MyAppointments;
export { myAppointmentsAdapter };
